/* Native <details> and Shopify forms remain usable without this enhancement. */
(() => {
  if (window.exhibelaShellInitialized) return;
  window.exhibelaShellInitialized = true;

  const disclosures = (root = document) => root.querySelectorAll('[data-ex-header] details[data-ex-disclosure]');
  const summary = (details) => details.querySelector(':scope > summary');
  const sync = (details) => summary(details)?.setAttribute('aria-expanded', String(details.open));
  const close = (details, restoreFocus = false) => {
    details.open = false;
    sync(details);
    if (restoreFocus) summary(details)?.focus();
  };
  const initialize = (root = document) => disclosures(root).forEach(sync);

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('[data-ex-header] details[data-ex-disclosure]')) return;
    sync(details);
    if (!details.open) return;
    disclosures(details.closest('[data-ex-header]')).forEach((other) => {
      if (other !== details && !other.contains(details) && !details.contains(other) && other.open) close(other);
    });
  }, true);

  document.addEventListener('click', (event) => {
    disclosures().forEach((details) => {
      if (details.open && !details.contains(event.target)) close(details);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = event.target.closest?.('[data-ex-header]');
    if (!header) return;
    const openDetails = Array.from(disclosures(header)).filter((details) => details.open);
    const active = openDetails.reverse().find((details) => details.contains(event.target)) || openDetails[0];
    if (active) {
      event.preventDefault();
      close(active, true);
    }
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  const desktop = window.matchMedia('(min-width: 990px)');
  desktop.addEventListener('change', () => disclosures().forEach((details) => close(details)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
